import React, { useState } from "react";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { useTranslation } from "react-i18next";
import ComboboxComponent from "../Combobox";
import { ARTICLE_GROUP_TYPES } from "./AkfaPositionPicker";

export const EMPTY_PRODUCT_FORM = {
    name: "",
    article: "",
    articleGroupType: "PROFILES",
    length: "",
    unitId: null,
    supplierId: null,
    productSeriesId: null,
};

const inputClass =
    "block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm";

// "Yangi WinPro mahsuloti yaratish" rejimi — product-draft bilan oldindan to'ldiriladi
export default function AkfaCreateProductForm({ form, setForm, textureIds, setTextureIds, lists }) {
    const { t } = useTranslation();
    const [textureQuery, setTextureQuery] = useState("");

    const setField = (key, value) => setForm((prev) => ({ ...prev, [key]: value }));

    const findById = (list, id) => (id ? list.find((item) => item.id === id) || null : null);

    const filteredTextures = textureQuery
        ? lists.textures.filter((tx) => tx.name?.toLowerCase().includes(textureQuery.toLowerCase()))
        : lists.textures;

    const toggleTexture = (id) =>
        setTextureIds(textureIds.includes(id) ? textureIds.filter((x) => x !== id) : [...textureIds, id]);

    return (
        <div className="space-y-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700">{t("name")} *</label>
                    <input
                        type="text"
                        value={form.name}
                        onChange={(e) => setField("name", e.target.value)}
                        className={inputClass}
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700">{t("article")} *</label>
                    <input
                        type="text"
                        value={form.article}
                        onChange={(e) => setField("article", e.target.value)}
                        className={inputClass}
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700">
                        {t("akfaIntegrationPage.create.article_group_type")} *
                    </label>
                    <select
                        value={form.articleGroupType}
                        onChange={(e) => setField("articleGroupType", e.target.value)}
                        className={inputClass}
                    >
                        {ARTICLE_GROUP_TYPES.map((type) => (
                            <option key={type} value={type}>
                                {t(type)}
                            </option>
                        ))}
                    </select>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700">{t("length")}</label>
                    <input
                        type="number"
                        step={0.001}
                        value={form.length}
                        onChange={(e) => setField("length", e.target.value)}
                        className={inputClass}
                    />
                </div>
                <ComboboxComponent
                    label={t("unit")}
                    data={lists.units}
                    item={findById(lists.units, form.unitId)}
                    onChange={(value) => setField("unitId", value?.id ?? null)}
                />
                <ComboboxComponent
                    label={t("supplier")}
                    data={lists.suppliers}
                    item={findById(lists.suppliers, form.supplierId)}
                    onChange={(value) => setField("supplierId", value?.id ?? null)}
                />
                <ComboboxComponent
                    label={t("series")}
                    data={lists.series}
                    item={findById(lists.series, form.productSeriesId)}
                    onChange={(value) => setField("productSeriesId", value?.id ?? null)}
                />
            </div>

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                    {t("akfaIntegrationPage.create.textures")} *
                </label>
                {textureIds.length > 0 && (
                    <div className="flex flex-wrap gap-2 mb-2">
                        {textureIds.map((id) => (
                            <span
                                key={id}
                                className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-indigo-50 text-indigo-700 text-xs font-medium"
                            >
                                {findById(lists.textures, id)?.name || `#${id}`}
                                <button type="button" onClick={() => toggleTexture(id)} className="hover:text-indigo-900">
                                    <XMarkIcon className="w-3.5 h-3.5" />
                                </button>
                            </span>
                        ))}
                    </div>
                )}
                <input
                    type="text"
                    value={textureQuery}
                    onChange={(e) => setTextureQuery(e.target.value)}
                    placeholder={t("akfaIntegrationPage.create.texture_search")}
                    className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 mb-2"
                />
                <div className="border border-gray-200 rounded-md max-h-48 overflow-y-auto">
                    {filteredTextures.map((tx) => (
                        <label
                            key={tx.id}
                            className="flex items-center gap-2 px-3 py-1.5 border-b last:border-b-0 text-sm cursor-pointer hover:bg-gray-50"
                        >
                            <input
                                type="checkbox"
                                checked={textureIds.includes(tx.id)}
                                onChange={() => toggleTexture(tx.id)}
                                className="h-4 w-4 rounded border-gray-300 text-indigo-600"
                            />
                            {tx.name}
                        </label>
                    ))}
                </div>
            </div>
        </div>
    );
}
